import React, { Component } from 'react'

class ParrainCode extends Component {
  render() {
    const { match } = this.props
    if (match) {
      if (match.params.userCode) {
        //localStorage.setItem('ApsBeninParentCodeStorage', JSON.stringify(match.params.userCode))
        window.location.replace(`https://tarification.aps-benin.com/?code=${match.params.userCode}`)
      }else if (match.params.devisCourtierCode) {
        //localStorage.setItem('ApsBeninParentCodeStorage', JSON.stringify(match.params.devisCourtierCode))
        window.location.replace(`https://tarification.aps-benin.com/?code=${match.params.devisCourtierCode}`)
      } else if (match.params.courtierCode) {
        //localStorage.setItem('ApsBeninParentCodeStorage', JSON.stringify(match.params.courtierCode))
        window.location.replace(`https://tarification.aps-benin.com/?code=${match.params.courtierCode}`)
      }
    }
    return(<div> </div>)
  }
}   

export default ParrainCode



// WEBPACK FOOTER //
// ./src/containers/ParentCode/index.js